const { VUE_APP_TOKEN_PATH } = process.env;

const VUE_APP_USER_TOKEN = VUE_APP_TOKEN_PATH || 'session-token';

export default {
    getToken(): string | null {
        const data = localStorage.getItem(VUE_APP_USER_TOKEN);
        return data && atob(JSON.parse(data));
    },
    saveToken(token: string): void {
        return localStorage.setItem(VUE_APP_USER_TOKEN, JSON.stringify(btoa(token)));
    },
    clearToken(): void {
        return localStorage.removeItem(VUE_APP_USER_TOKEN);
    },
};
